import React from "react";
import { Box, Chip } from "@mui/material";
import { Error as ErrorIcon, Warning as WarningIcon } from "@mui/icons-material";
import type { DiagnosticEvents } from "./types";
import { getEventsCount } from "./types";

interface DiagnosticCountChipsProps {
  events?: DiagnosticEvents;
  size?: "small" | "medium";
}

export function DiagnosticCountChips({
  events,
  size = "small",
}: DiagnosticCountChipsProps) {
  const counts = getEventsCount(events);

  if (counts.errors === 0 && counts.warns === 0) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
      {counts.errors > 0 && (
        <Chip
          icon={<ErrorIcon />}
          label={counts.errors}
          size={size}
          color="error"
        />
      )}
      {counts.warns > 0 && (
        <Chip
          icon={<WarningIcon />}
          label={counts.warns}
          size={size}
          color="warning"
        />
      )}
    </Box>
  );
}
